import React, { useState } from 'react'
import './sidebar.css' 
import { useLocation, useNavigate } from 'react-router-dom'
import { MdDashboard } from 'react-icons/md'
import { FaUser, FaUsers } from 'react-icons/fa'
import { AiFillTool } from 'react-icons/ai'
import { PiStudentFill } from 'react-icons/pi'
import { FaLocationDot } from 'react-icons/fa6'
import { GiDeadEye, GiOfficeChair } from 'react-icons/gi'
import { TbNotes } from 'react-icons/tb'
import { RiUserSettingsFill } from 'react-icons/ri'
import { IoMdCloseCircle } from 'react-icons/io'
import { ImSwitch } from 'react-icons/im'
import { useToggle } from '../context/ToggleContext'


const Header = () => {

  const { isActive, toggleState } = useToggle()
 
  const navigate = useNavigate()
  const location = useLocation();
  const isActiveLink = (link) => link === location.pathname;

  const routeChange = (el) => {
    navigate(el)
    toggleState(false); 
  }




  return (

    <div class='sidebarheader'>
      <div class='col-11 m-auto d-flex align-items-center justify-content-between'>
        <div class='d-flex align-items-center gap-4'>
          <img src={require('../images/logo.png')} style={{ height: '40px' }} alt="" />
          {
            !isActiveLink('/log-in') &&
            <div onClick={toggleState} data-bs-toggle="offcanvas" href="#aimsMenu" role="button" aria-controls="aimsMenu">
              <div class={`hml ${isActive ? 'hml1' : ''}`}></div>
              <div class={`hml ${isActive ? 'hml2' : ''}`}></div>
              <div class={`hml ${isActive ? 'hml3' : ''}`}></div>
            </div>
          }
        </div>
        {
          !isActiveLink('/log-in') &&
          <button class='btn btn-light fw-bold rounded-5 d-flex align-items-center gap-2' onClick={() => { localStorage.removeItem("aimsAdminToken"); navigate('/log-in') }}><ImSwitch class='text-danger' />Log-Out</button>
        }
      </div>
      <div class='mobileMenu'>

        <div class="offcanvas offcanvas-start " tabindex="-1" id="aimsMenu" aria-labelledby="aimsMenuLabel" style={{ background: '#034da2' }}>
          <div class="offcanvas-header d-flex align-items-center justify-content-between">
            <img src={require('../images/logo.png')} style={{ height: '40px' }} alt="" />
            <button class='btn text-white fs-1' data-bs-dismiss="offcanvas" aria-label="Close" onClick={toggleState}><IoMdCloseCircle /></button>
          </div>
          <div class="offcanvas-body">
            <div class='d-flex align-items-center gap-3 col-11 m-auto  ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/dashboard') ? { background: 'white', color: "#034da2" } : {}}>
                <MdDashboard />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/dashboard') ? { fontWeight: '700' } : {}}  >Dashboard</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/members')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/members') ? { background: 'white', color: "#034da2" } : {}}>
                <FaUsers />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/members') ? { fontWeight: '700' } : {}}  >Members</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} data-bs-toggle="collapse" href="#masterCollapse" role="button" aria-expanded="false" aria-controls="masterCollapse">
                   <div class='sliderIcon' style={location.pathname.split('-')[0].replace('/', '') == "masters" ? { background: 'white', color: "#034da2" } : {}}>
                     <AiFillTool />
                   </div>
                   <p class={`sliderText ${isActive ? 'active' : ''}`} style={location.pathname.split('-')[0].replace('/', '') == "masters" ? { fontWeight: '700' } : {}}  >Masters <i class="bi bi-caret-down-fill"></i></p>
                 </div>
         
                 <div class="collapse mt-2" id="masterCollapse">
                   <div class="py-3" style={{ background: 'rgba(255,255,255,0.2)' }}>
                     <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/masters-education-occupation')} data-bs-dismiss="offcanvas" aria-label="Close">
                       <div class='sliderIcon' style={isActiveLink('/masters-education-occupation') ? { background: 'white', color: "#034da2" } : {}}>
                         <PiStudentFill />
                       </div>
                       <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-education-occupation') ? { fontWeight: '700' } : {}}  >Education/Occupation</p>
                     </div>
         
                     <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />
         
                     <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/masters-location')} data-bs-dismiss="offcanvas" aria-label="Close">
                       <div class='sliderIcon' style={isActiveLink('/masters-location') ? { background: 'white', color: "#034da2" } : {}}>
                         <FaLocationDot />
                       </div>
                       <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-location') ? { fontWeight: '700' } : {}}  >Location</p>
                     </div>
         
                     <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />
         
                     <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/masters-skills')} data-bs-dismiss="offcanvas" aria-label="Close">
                       <div class='sliderIcon' style={isActiveLink('/masters-skills') ? { background: 'white', color: "#034da2" } : {}}>
                         <GiDeadEye />
                       </div>
                       <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-skills') ? { fontWeight: '700' } : {}}  >Skills</p>
                     </div>
         
                     <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />
         
                     <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/masters-designation')} data-bs-dismiss="offcanvas" aria-label="Close">
                       <div class='sliderIcon' style={isActiveLink('/masters-designation') ? { background: 'white', color: "#034da2" } : {}}>
                         <GiOfficeChair />
                       </div>
                       <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters-designation') ? { fontWeight: '700' } : {}}  >Designation</p>
                     </div>
         
                   </div>
                 </div>

            {/* <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/masters')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/masters') ? { background: 'white', color: "#034da2" } : {}}>
                <AiFillTool />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/masters') ? { fontWeight: '700' } : {}}  >Master</p>
            </div> */}



            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />

            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} data-bs-toggle="collapse" href="#reportsCollapse" role="button" aria-expanded="false" aria-controls="reportsCollapse">
              <div class='sliderIcon' style={location.pathname.split('-')[0].replace('/', '') == "reports" ? { background: 'white', color: "#034da2" } : {}}>
                <TbNotes />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={location.pathname.split('-')[0].replace('/', '') == "reports" ? { fontWeight: '700' } : {}}  >Reports <i class="bi bi-caret-down-fill"></i></p>
            </div>
            <div class="collapse mt-2" id="reportsCollapse">
              <div class="py-3" style={{ background: 'rgba(255,255,255,0.2)' }}>
                <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/reports-education-occupation')} data-bs-dismiss="offcanvas" aria-label="Close">
                  <div class='sliderIcon' style={isActiveLink('/reports-education-occupation') ? { background: 'white', color: "#034da2" } : {}}>
                    <PiStudentFill />
                  </div>
                  <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/reports-education-occupation') ? { fontWeight: '700' } : {}}  >Education/Occupation</p>
                </div>

              </div>
            </div>

            {/* <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/reports')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/reports') ? { background: 'white', color: "#034da2" } : {}}>
                <TbNotes />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/reports') ? { fontWeight: '700' } : {}}  >Reports</p>
            </div> */}

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />


            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/users')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/users') ? { background: 'white', color: "#034da2" } : {}}>
                <FaUser />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/users') ? { fontWeight: '700' } : {}}  >Users</p>
            </div>

            <div class='col-11 m-auto  my-2 bg-white' style={{ height: '0.5px' }} />


            <div class='d-flex align-items-center gap-3 col-11 m-auto ' style={isActive ? { justifyContent: 'start', cursor: 'pointer' } : { justifyContent: 'center', cursor: 'pointer' }} onClick={() => routeChange('/role')} data-bs-dismiss="offcanvas" aria-label="Close">
              <div class='sliderIcon' style={isActiveLink('/role') ? { background: 'white', color: "#034da2" } : {}}>
                <RiUserSettingsFill />
              </div>
              <p class={`sliderText ${isActive ? 'active' : ''}`} style={isActiveLink('/role') ? { fontWeight: '700' } : {}}  >Role</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default Header